import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { itIT } from '@mui/x-date-pickers/locales';
import moment from 'moment';
import 'moment/locale/it';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { selectDialogOpened } from '../../store/dialog/dialog.selector';
import { setIsError } from '../../store/error/error.action';
import {
    selectErrorMessage,
    selectIsError,
} from '../../store/error/error.selector';
import DialogWrapper from '../dialogs/dialog-wrapper.component';
import ErrorSnackbar from '../ui/error-snackbar/error-snackbar.component';
import ContentWrapper from './content-wrapper/content-wrapper.component';
import { FlexBoxFullWHColumn } from './layout.styles';
import TopBar from './top-bar/top-bar.component';
moment.locale('it');

export default function Layout() {
    const dispatch = useDispatch();

    const error = useSelector(selectIsError);
    const errorMessage = useSelector(selectErrorMessage);
    const dialogOpened = useSelector(selectDialogOpened);

    const location = useLocation();

    const handleCloseSnackbar = () => {
        dispatch(setIsError(false, null));
    };

    return (
        <LocalizationProvider
            dateAdapter={AdapterMoment}
            localeText={
                itIT.components.MuiLocalizationProvider.defaultProps.localeText
            }
            adapterLocale="it"
        >
            <FlexBoxFullWHColumn overflow={'hidden'}>
                {error && (
                    <ErrorSnackbar
                        open={true}
                        msg={errorMessage}
                        onClose={handleCloseSnackbar}
                    />
                )}
                {dialogOpened && <DialogWrapper />}
                {location.pathname !== '/login' && <TopBar />}
                <ContentWrapper />
            </FlexBoxFullWHColumn>
        </LocalizationProvider>
    );
}
